import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Router} from '@angular/router';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private router: Router) {
    }

    getCookie(name) {
        var nameEQ = name + '=';
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) == 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return '';
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // Lambda publique : son CORS refuse les en-têtes custom ajoutés plus bas
        if (request.url.includes('/default/simu_emprunt')) {
            return next.handle(request);
        }

        // TODO : Move to other interceptor
        let fbp = '';
        let fbc = '';

        let result = /_fbp=(fb\.1\.\d+\.\d+)/.exec(window.document.cookie);
        if (result && result[1]) {
            fbp = result[1];
        }

        result = /_fbc=(fb\.1\.\d+\.\S+)/.exec(window.document.cookie);
        if (result && result[1]) {
            fbc = result[1];
        }

        if (fbc == '') {
            result = /lx_fbid=(fb\.1\.\d+\.\S+)/.exec(window.document.cookie);
            if (result && result[1]) {
                fbc = result[1];
            }
        }

        const datafastVisitorId = this.getCookie('datafast_visitor_id');
        const datafastSessionId = this.getCookie('datafast_session_id');

        // add authorization header with jwt token if available
        const token = localStorage.getItem('token');

        if (token) {
            if (request.url.includes('wikipedia')) {
            } else if (request.url.includes('/default/impot')) {
                request = request.clone({
                    setHeaders: {
                        Authorization: `${token}`,
                    }
                });
            } else {
                request = request.clone({
                    setHeaders: {
                        Authorization: `${token}`,
                        RequestUrl: this.router.url,
                        Fbp: fbp,
                        Fbc: fbc,
                        'X-Datafast-Visitor-Id': datafastVisitorId,
                        'X-Datafast-Session-Id': datafastSessionId,
                    }
                });
            }
        } else if (request.url.includes('/default/impot') === false) {
            request = request.clone({
                setHeaders: {
                    RequestUrl: this.router.url,
                    Fbp: fbp,
                    Fbc: fbc,
                    'X-Datafast-Visitor-Id': datafastVisitorId,
                    'X-Datafast-Session-Id': datafastSessionId,
                }
            });
        }

        return next.handle(request);
    }
}
